type SectionLabelProps = {
  children: string;
  className?: string;
};

/** Eyebrow label: short rule + uppercase tracked text. */
export function SectionLabel({ children, className = "" }: SectionLabelProps) {
  return (
    <p
      className={`inline-flex items-center gap-3 text-[0.6875rem] font-medium uppercase tracking-[0.28em] text-muted ${className}`}
    >
      <span
        className="h-px w-8 shrink-0 bg-muted/80 md:w-10"
        aria-hidden="true"
      />
      <span>{children}</span>
    </p>
  );
}
